<template>
    <v-app id='app' toolbar--fixed toolbar :style="{background: $vuetify.theme.themes[theme].background}">
      <v-app-bar fixed app scroll-off-screen tabs class='mainmenu white--text' color='#6441a4'>
        <v-menu>
          <template v-slot:activator="{ on }">
              <v-app-bar-nav-icon v-on="on" dark></v-app-bar-nav-icon>
          </template>
          <v-list>
            <v-list-item v-for='item in menu' :key='item.to' :to='item.to'>
              <v-list-item-content>
                <v-list-item-title><v-icon class='mr-3'>{{item.icon}}</v-icon>{{ item.title }}</v-list-item-title>
               </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-checkbox hide-details class="ma-0 pa-0" label="Dark Mode" v-model="$vuetify.theme.dark"></v-checkbox>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-toolbar-title :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : ''">ANZ Streamer Directory</v-toolbar-title>

        <v-spacer></v-spacer>
        <span v-if="$vuetify.breakpoint.smAndUp">{{this.subtitle}}</span>
        <v-btn v-if="$vuetify.breakpoint.mdAndUp" @click='toggleDark' text style='min-width: 8px'><v-icon small color="white">{{this.$vuetify.theme.dark ? 'mdi-brightness-5': 'mdi-brightness-2'}}</v-icon></v-btn>
       
        <template v-slot:extension :subtitle="subtitle" class='pa-0'>
          <v-tabs fixed-tabs centered class='pa-0' background-color='#6441a4' color="white" dark v-if='$vuetify.breakpoint.smAndUp'>
            <v-tab style="max-width: 200px" v-for='item in menu' :key='item.to' :to='item.to'>{{item.title}}</v-tab>
          </v-tabs>
          <span class="pl-4 subheading" v-if='$vuetify.breakpoint.xsOnly'>{{subtitle}}</span>
        </template>
      </v-app-bar>

      <div id='mainContent'>
        <v-content>
            <router-view @errorUpdate='errorUpdate' @subtitleUpdate='subtitleUpdate' />
        </v-content>
      </div>
      <v-footer class="pa-3 justify-center" style="margin-top: 180px">
        This site has NO official affiliation with Twitch. A project made by the community for the community. 
      </v-footer>
      <v-snackbar v-model="showError" color="error" :timeout="10000" top>
        {{ this.errorText }}
        <v-btn dark text @click="showError = false">Close</v-btn>
      </v-snackbar>
    </v-app>
</template>

<script>
import 'vuetify/dist/vuetify.min.css'

export default {
  name: 'App',
  data () {
    return {
      menu: [
        { icon: 'mdi-home', title: 'Home', to: '/' },
        // { icon: 'fas fa-address-book', title: 'Directory', to: '/directory'  },
        { icon: 'fas fa-user-friends', title: 'Teams', to: '/teams'  },
        { icon: 'mdi-magnify', title: 'Clip Search Tool', to: '/clips'  },
        { icon: 'mdi-magnify', title: 'Video Tool', to: '/vods'  },
        { icon: 'mdi-information', title: 'About', to: '/about'  },
      ],
      subtitle: '',
      errorText: '',
      showError: false,
    }
  },
  created() {
    this.$vuetify.theme.dark = localStorage.dark == 0 ? false : true
  },
  computed: {
     theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
  methods: {
    subtitleUpdate: function(s) {
      this.subtitle = s
    },
    toggleDark: function() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.dark = this.$vuetify.theme.dark ? 1 : 0
    },
    errorUpdate: function(e) {
      this.errorText = e
      this.showError = true
    },
  }
}
</script>

<style>
  tbody tr:nth-of-type(odd) {
     background-color: rgba(0, 0, 0, .15);
   }

  .mainmenu > .v-toolbar__extension {
    padding: 0;
  }   
</style>